// pon_sizeorder.js

(function ($) {
  "use strict";

  // =========================
  // 定数
  // =========================
  const ITEM_ID    = "10107777";
  const SHOP_BID   = "203706";
  const VARIANT_ID = "555a00044";

  const BASE_IMG = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/pon/";

  const LIMITS = {
    haba:  { min: 40, max: 90, label: "幅" },
    depth: { min: 60, max: 90, label: "奥行" }
  };

  const FABRIC_BAND = {
    A: ["ns7", "sofia", "modern"],
    B: ["resort"],
    C: ["holiday", "denim", "leather", "meta", "magic", "cuera"]
  };

  // 価格表行オフセット
  const ROW_BASE = {
    "1P": { A: 0,  B: 4,  C: 8  },
    "ot": { A: 12, B: 16, C: 20 }
  };

  // material_bubble（生地選択時）
  const FABRIC_MATERIAL_TEXT = {
    ns7:    "材質：ポリエステル48%、綿32%、アクリル20%",
    sofia:  "ポリエステル100%(撥水加工・ノーホルマリン加工済)",
    modern: "ポリエステル100%(撥水加工・ノーホルマリン加工済)",
    denim:  "材質：ポリエステル48%、綿32%、アクリル20%",
    resort: "材質：ポリエステル100%",
    holiday:"材質：ポリエステル100%",
    leather:"材質：ポリウレタン100%(合皮)",
    meta:   "材質：PVC100%(合皮)<br>※抗菌機能付き生地使用",
    magic:  "材質：PVC100%(合皮)<br>※防汚・抗菌機能付き生地使用",
    cuera: "材質：ポリエステル100%(ペット対応・軽撥水加工)"
  };

  // material_bubble（カラー選択時）
  const COLOR_DESC_TEXT = {
    ns7:    "少し硬めのスッキリとした肌ざわり。繊維が立っていないので糸くず等が絡まりにくく汚れにくいのが特徴です。",
    sofia:  "ほんのり起毛した優しい肌触り。ノーホルマリン加工でシックハウス症候群の心配がありません。撥水加工が施されています。",
    modern: "落ち着いたアースカラーのモダン生地。ほんのり起毛しており、撥水加工が施されています。",
    denim:  "少し硬めでスッキリとした手触りのデニム生地。カジュアルや西海岸風など幅広いテイストに合う生地です。",
    resort: "発色の良いカラーを取り揃えたリゾート生地。かすり調で派手過ぎず、大人っぽく見せてくれます。",
    holiday:"ゆったりと過ごす大人の休日を表しているかのようなカラーリングのホリデイ生地。どんなお部屋にも馴染みます。",
    leather:"汚れてもさっと拭き取ることができ、お手入れも簡単。革のような風合いなのでオフィスや待合室にぴったり。",
    meta:   "ムラ感のある上品な表情に仕上げたアンティーク調レザー。",
    magic:  "防汚・抗菌機能が備わった生地でお子様や人が沢山使う場所に最適。",
    cuera: "ひっかきキズにも強い、なめらかでしっとりとしたタッチ感のスエード調ファブリック。"
  };

  // =========================
  // 状態（CSV）
  // =========================
  let priceTable = null;   // 2D array (24 x 6)
  let existingList = null; // arrays

  // =========================
  // ユーティリティ
  // =========================
  function onlyDigits(v) {
    return String(v ?? "").replace(/[^\d]/g, "");
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === "";
    const n = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el, val: n, isEmpty };
  }

  function ceil10(n) {
    return Math.ceil(n / 10) * 10;
  }

  function formatYen(n) {
    const s = String(n ?? "").replace(/[^\d]/g, "");
    if (s === "") return "";
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "円";
  }

  function getShape() {
    const plate = document.querySelector('input[name="top_plate"]:checked');
    if (!plate) return "1P";
    return plate.id === "plate_right" ? "ot" : "1P";
  }

  function getLegHeight() {
    const opt = document.querySelector('input[name="option"]:checked');
    if (!opt) return NaN;
    const m = String(opt.id || opt.value || "").match(/(\d+)\s*cm|^(\d+)/);
    const n = parseInt(m?.[1] || m?.[2] || "", 10);
    return Number.isNaN(n) ? NaN : n;
  }

  function getLegColorToken() {
    const opt = document.querySelector('input[name="option"]:checked');
    const id = (opt?.id || "").toLowerCase();
    const val = String(opt?.value || "");
    if (id.includes("na") || val.indexOf("ナチュラル") !== -1) return "nt";
    return "dbr";
  }


  function getFabricType() {
    const el = document.querySelector('input[name="colortype1"]:checked');
    return (el?.dataset?.type || "").toLowerCase();
  }

  function getFabricName() {
    const el = document.querySelector('input[name="colortype1"]:checked');
    return el ? el.value : "";
  }

  function getColorName() {
    const el = document.querySelector('input[name="colortype2"]:checked');
    return el ? el.value : "";
  }

  function getColorId() {
    const el = document.querySelector('input[name="colortype2"]:checked');
    return el ? el.id : "";
  }

  function getBandByFabric(type) {
    if (!type) return null;
    const t = type.toLowerCase();
    if (FABRIC_BAND.A.includes(t)) return "A";
    if (FABRIC_BAND.B.includes(t)) return "B";
    if (FABRIC_BAND.C.includes(t)) return "C";
    return null;
  }

  function $sizeMsg() {
    const node = document.querySelector(".form_size + .msg");
    return node ? $(node) : $();
  }

  function $orderMsg() {
    return $(".order-summary > .msg");
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector(".check_price");
    const cart  = document.querySelector(".cart--btn");
    if (price) price.setAttribute("style", on ? "" : "visibility: hidden");
    if (cart) {
      if (on) cart.removeAttribute("disabled");
      else cart.setAttribute("disabled", "");
    }
  }

  function resetOrderSummary() {
    const $msg = $orderMsg();
    $msg.empty();

    $(".check_area li span").text("");
    const $price = $(".check_price");
    $price.empty();
    $price.attr("style", "visibility: hidden");

    setCheckoutUIEnabled(false);

    $("#units").val("");
  }

  // =========================
  // CSV ロード
  // =========================
  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/pon_price.csv?v=1783476412", dataType: "text" })
      .then((text) => {
        priceTable = $.csv.toArrays(text).map(row => row.map(v => parseInt(String(v).replace(/[^\d]/g, ""), 10)));
        return priceTable;
      })
      .catch(() => {
        priceTable = [];
        return priceTable;
      });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/pon_existing.csv?v=1771473132", dataType: "text" })
      .then((text) => {
        existingList = $.csv.toArrays(text);
        return existingList;
      })
      .catch(() => {
        existingList = [];
        return existingList;
      });
  }

  // =========================
  // サイズ：座面奥行 / エラー（blur）
  // =========================
  function updateSeatDepth() {
    const shape = getShape();
    const $liSeat = $(".form_size--txt li:contains('奥行(座面)')");
    if (shape === "ot") {
      $liSeat.hide();
      $("#seat_depth").val("");
      return;
    }
    $liSeat.show();

    const d = readInt("depth").val;
    if (!Number.isNaN(d)) {
      const seat = d - 23;
      $("#seat_depth").val(seat > 0 ? seat : "");
    } else {
      $("#seat_depth").val("");
    }
  }

  function validateSizeForBlur() {
    const $msg = $sizeMsg();
    $msg.empty();

    const errs = [];

    const h = readInt("haba");
    const d = readInt("depth");

    function pushErr(lim, val, isEmpty) {
      if (isEmpty) {
        errs.push(`<p class="note-size-error">${lim.label}は${lim.min}〜${lim.max}cmの範囲で入力してください（現在：未入力）</p>`);
        return;
      }
      if (Number.isNaN(val)) {
        errs.push(`<p class="note-size-error">${lim.label}は${lim.min}〜${lim.max}cmの範囲で入力してください（現在：未入力）</p>`);
        return;
      }
      if (val < lim.min || val > lim.max) {
        errs.push(`<p class="note-size-error">${lim.label}は${lim.min}〜${lim.max}cmの範囲で入力してください（現在：${val}cm）</p>`);
      }
    }

    pushErr(LIMITS.haba, h.val, h.isEmpty);
    pushErr(LIMITS.depth, d.val, d.isEmpty);

    if (errs.length) {
      $msg.append(errs.join(""));
      return false;
    }
    return true;
  }

  // =========================
  // material_bubble
  // =========================
  function setBubble(sectionEl, htmlOrText) {
    const $b = $(sectionEl).find(".material_bubble").first();
    if (!$b.length) return;
    $b.html(htmlOrText);
  }

  function hydrateFabricBubble() {
    const type = getFabricType();
    const section = document.querySelector('input[name="colortype1"]')?.closest(".form.material");
    if (!section) return;
    if (type && FABRIC_MATERIAL_TEXT[type]) setBubble(section, FABRIC_MATERIAL_TEXT[type]);
    else setBubble(section, "選択してください");
  }

  function hydrateColorBubble() {
    const type = (document.querySelector('input[name="colortype2"]:checked')?.dataset?.type || "").toLowerCase();
    const section = document.querySelector('input[name="colortype2"]')?.closest(".form.material");
    if (!section) return;
    if (type && COLOR_DESC_TEXT[type]) setBubble(section, COLOR_DESC_TEXT[type]);
    else setBubble(section, "選択してください");
  }

  // =========================
  // カラー絞り込み（Splide remove/add）
  // =========================
  let __colorOriginalSlides = null;

  function getColorSplideRoot() {
    return document.querySelector('.splide[aria-label="カラーを選択"]')
      || document.querySelector("#splide03")
      || document.querySelectorAll(".splide")[2]
      || null;
  }

  function cacheColorSlidesOnce(colorRoot) {
    if (!colorRoot) return;
    if (__colorOriginalSlides) return;

    const list = colorRoot.querySelector(".splide__list");
    if (!list) return;

    __colorOriginalSlides = [];
    list.querySelectorAll(".splide__slide").forEach(slide => {
      __colorOriginalSlides.push(slide.outerHTML);
    });
  }

  function rebuildColorSlidesByType(type) {
    const colorRoot = getColorSplideRoot();
    if (!colorRoot) return;

    cacheColorSlidesOnce(colorRoot);

    const splide = (window.__splideMap && window.__splideMap.get(colorRoot)) || colorRoot.splide || null;
    if (!splide) return;

    const targetType = (type || "").toLowerCase();

    // (1) 既存スライドを全 remove
    try {
      const len = (typeof splide.length === "number") ? splide.length : (splide.Components?.Slides?.getLength?.() ?? 0);
      for (let i = len - 1; i >= 0; i--) splide.remove(i);
    } catch (_) {
      // fallback: remove(0) ループ
      try {
        for (let i = 0; i < 200; i++) {
          if ((splide.length ?? 0) <= 0) break;
          splide.remove(0);
        }
      } catch (_) {}
    }

    // (2) 対象スライドを add
    const htmls = (__colorOriginalSlides || []).filter(html => {
      const m = html.match(/name="colortype2"[^>]*data-type="([^"]+)"/i);
      const t = (m?.[1] || "").toLowerCase();
      return t === targetType;
    });

    const addTargets = (htmls.length ? htmls : (__colorOriginalSlides || []));
    addTargets.forEach(html => {
      try { splide.add(html); } catch (_) {}
    });

    // (3) refresh → go(0)
    try { splide.refresh(); } catch (_) {}
    try { splide.go(0); } catch (_) {}

    // 対象先頭を自動選択
    const list = colorRoot.querySelector(".splide__list");
    const first = list?.querySelector('input[name="colortype2"]') || null;
    if (first) {
      first.checked = true;
      first.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // =========================
  // 画像切替
  // =========================
  function updatePreviewImages() {
    const shape = getShape();
    const shapeDir = (shape === "ot") ? "ot" : "1p";

    const area1 = document.querySelector('img[name="area1"]');
    const area2 = document.querySelector('img[name="area2"]');
    const area3 = document.querySelector('img[name="area3"]');

    if (area1) area1.src = `${BASE_IMG}${shapeDir}/arrow.png`;

    const colorId = getColorId();
    if (area2 && colorId) {
      area2.src = `${BASE_IMG}${shapeDir}/${colorId}.png`;
    }

    if (area3) {
      const legTok = getLegColorToken();
      area3.src = `${BASE_IMG}leg/${legTok}.png`;
    }
  }

  // =========================
  // サイズ図：img 幅/高さ
  // =========================
  function resizeFormSizeImages() {
    const container = document.querySelector(".form_size--img");
    if (!container) return;

    const width = container.offsetWidth;
    const imgs = container.querySelectorAll("img");

    imgs.forEach(img => { img.style.width = width + "px"; });

    // pon は先頭画像が小さいため、全 img の最大高さを採用
    let maxH = 0;
    imgs.forEach(img => {
      const h = img.offsetHeight || 0;
      if (h > maxH) maxH = h;
    });

    if (maxH > 0) container.style.height = maxH + "px";
  }

  function bindResizeAfterLoad() {
    const container = document.querySelector(".form_size--img");
    if (!container) return;
    const imgs = container.querySelectorAll("img");
    imgs.forEach(img => {
      img.addEventListener("load", resizeFormSizeImages, { passive: true });
    });
  }

  // =========================
  // 既製品誘導
  // =========================
  function findExistingCode(params) {
    if (!Array.isArray(existingList) || existingList.length === 0) return null;
    const { shape, w, d, h, fabricType, legH } = params;

    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i];
      if (!row || row.length < 7) continue;

      const code = String(row[0] ?? "").trim();
      const rShape = String(row[1] ?? "").trim();
      const rW = parseInt(String(row[2] ?? "").replace(/[^\d]/g, ""), 10);
      const rD = parseInt(String(row[3] ?? "").replace(/[^\d]/g, ""), 10);
      const rH = parseInt(String(row[4] ?? "").replace(/[^\d]/g, ""), 10);
      const rFabric = String(row[5] ?? "").trim().toLowerCase();
      const rLeg = parseInt(String(row[6] ?? "").replace(/[^\d]/g, ""), 10);

      if (!code) continue;

      // 座面奥行は無視、脚は数値一致
      if (
        rShape.toLowerCase() === String(shape).toLowerCase() &&
        rW === w &&
        rD === d &&
        rH === h &&
        rFabric === String(fabricType).toLowerCase() &&
        rLeg === legH
      ) {
        return code;
      }
    }
    return null;
  }

  // =========================
  // choice / units 更新
  // =========================
  function setChoiceValues({ price, haba, depth }) {
    const shape = getShape();
    const typeText = (shape === "ot") ? "オットマンタイプ" : "一人掛けタイプ";

    const fabricName = getFabricName();
    const colorName = getColorName();

    const legVal = document.querySelector('input[name="option"]:checked')?.value || "";

    const choice1 = `形：${typeText}/`;
    const choice2 = `幅：${haba}cm/`;
    const choice3 = `奥行：${depth}cm/`;
    const choice4 = `生地：${fabricName}/`;
    const choice5 = `カラー：${colorName}/`;
    const choice6 = `脚：${legVal}/`;
    const choice7 = `見積もり金額：${price}`;

    $("#choice1").val(choice1);
    $("#choice2").val(choice2);
    $("#choice3").val(choice3);
    $("#choice4").val(choice4);
    $("#choice5").val(choice5);
    $("#choice6").val(choice6);
    $("#choice7").val(choice7);

    const units = Math.round(price / 100);
    $("#units").val(String(units));
  }

  function buildEncodedChoice() {
    const lines = [
      $("#choice1").val(),
      $("#choice2").val(),
      $("#choice3").val(),
      $("#choice4").val(),
      $("#choice5").val(),
      $("#choice6").val(),
      $("#choice7").val()
    ].filter(v => String(v ?? "").length > 0);

    const choice = lines.join("\r\n");

    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: "EUCJP", from: "UNICODE" });
    return Encoding.urlEncode(eucArray);
  }

  // =========================
  // カート投入
  // =========================
  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    const units = $("#units").val();
    const c1 = $("#choice1").val();
    const c7 = $("#choice7").val();
    if (!units || !c1 || !c7) return false;

    const encodedChoice = buildEncodedChoice();

    const existingForm = document.querySelector("form[name='cart_form_ori']");
    if (existingForm) existingForm.remove();

    const form = document.createElement("form");
    form.method = "post";
    form.name = "cart_form_ori";
    form.action = "https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set";
    form.acceptCharset = "EUC-JP";
    form.target = "_blank";

    const inputs = [
      { name: "shop_bid", value: SHOP_BID },
      { name: "item_id", value: ITEM_ID },
      { name: "variant_id", value: VARIANT_ID },
      { name: "units", value: units },
      { name: "choice", value: encodedChoice }
    ];

    inputs.forEach(d => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    return false;
  }

  // =========================
  // 金額算出（jump）
  // =========================
  window.jump = function () {
    const $msg = $orderMsg();
    $msg.empty();

    const errors = [];

    const h = readInt("haba");
    const d = readInt("depth");

    function requireInRange(r, lim) {
      if (r.isEmpty) { errors.push(`${lim.label}を入力してください`); return; }
      if (Number.isNaN(r.val)) { errors.push(`${lim.label}は数値(半角)で入力してください`); return; }
      if (r.val < lim.min || r.val > lim.max) {
        errors.push(`${lim.label}は ${lim.min}～${lim.max}cm の範囲で入力してください（現在: ${r.val}cm）`);
      }
    }

    requireInRange(h, LIMITS.haba);
    requireInRange(d, LIMITS.depth);

    const fabricType = getFabricType();
    const band = getBandByFabric(fabricType);
    if (!band) errors.push("生地を選択してください");

    const color = document.querySelector('input[name="colortype2"]:checked');
    if (!color) errors.push("カラーを選択してください");

    const leg = document.querySelector('input[name="option"]:checked');
    if (!leg) errors.push("脚を選択してください");

    if (errors.length) {
      errors.forEach(t => $msg.append($('<p class="note-submit-error">').text(t)));
      setCheckoutUIEnabled(false);
      return false;
    }

    // 10cm刻みに切り上げ補正（エラーは出さない）
    const w10 = ceil10(h.val);
    const d10 = ceil10(d.val);

    const wIndex = Math.round((w10 - 40) / 10);
    const dIndex = Math.round((d10 - 60) / 10);

    const shape = getShape();
    const base = ROW_BASE[shape]?.[band];

    if (!Array.isArray(priceTable) || priceTable.length < 24 || base == null) {
      $msg.append($('<p class="note-submit-error">').text("価格表の読み込みに失敗しました"));
      setCheckoutUIEnabled(false);
      return false;
    }

    const row = base + dIndex;
    const col = wIndex;

    const raw = priceTable?.[row]?.[col];
    if (!Number.isFinite(raw)) {
      $msg.append($('<p class="note-submit-error">').text("価格が見つかりませんでした"));
      setCheckoutUIEnabled(false);
      return false;
    }

    let price = raw + 0;

    // 脚の高さ取得
    const legH = getLegHeight();

    // 15cm・20cmのみ加算（10cmは加算しない）
    if (legH === 15 || legH === 20) {
      price += 3000;
    }

    // 既製品誘導（判別は入力値そのまま、座面奥行は無視）
    const totalH = (shape === "ot") ? (legH + 22) : (legH + 45);
    const existingCode = findExistingCode({
      shape,
      w: h.val,
      d: d.val,
      h: totalH,
      fabricType,
      legH
    });

    if (existingCode) {
      $msg.append(
        `<p class="existing-link">
          <a href="https://interior-arne.com/products/${existingCode}" target="_blank">
            →既製品ページがございます。こちらのページよりお買い求めください。
          </a>
        </p>`
      );
      $(".check_price").empty().attr("style", "visibility: hidden");
      setCheckoutUIEnabled(false);
      $("#units").val("");
      return false;
    }

    // 確認欄へ反映
    const spans = document.querySelectorAll(".check_area ul li span");
    if (spans.length >= 6) {
      spans[0].textContent = (shape === "ot") ? "オットマンタイプ" : "一人掛けタイプ";
      spans[1].textContent = h.val;
      spans[2].textContent = d.val;
      spans[3].textContent = getFabricName();
      spans[4].textContent = getColorName();
      spans[5].textContent = (leg?.value || "");
    }

    // choice と units
    setChoiceValues({ price, haba: h.val, depth: d.val });

    // 金額表示（UI：金額のみ）
    $(".check_price").text(formatYen(price)).attr("style", "");

    // 成功メッセージ
    $msg.append(
      `<p class="note-submit-ok">
        以下の内容を確認し、買い物かごにお進みください。
      </p>`
    );

    setCheckoutUIEnabled(true);
    return false;
  };

  // =========================
  // 既存挙動に合わせたダミー（HTML inline）
  // =========================
  window.checkBtn = function () { return true; };

  // =========================
  // 初期化 & イベント
  // =========================
  $(function () {
    // CSV先読み
    loadPriceOnce();
    loadExistingOnce();

    // 初期状態：注文サマリー初期化
    resetOrderSummary();

    // サイズ図調整
    resizeFormSizeImages();
    bindResizeAfterLoad();
    $(window).on("resize", resizeFormSizeImages);

    // 形（オットマン）仕様
    updateSeatDepth();
    updatePreviewImages();

    // material_bubble 初期反映
    hydrateFabricBubble();
    hydrateColorBubble();

    // カラー絞り込み初期（sofia 選択済み前提）
    rebuildColorSlidesByType(getFabricType());
    updatePreviewImages();

    // 入力：数字以外除去
    $(document).on("input", "#haba, #depth", function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
    });

    // blur でサイズバリデーション
    $(document).on("blur", "#haba, #depth", function () {
      validateSizeForBlur();
    });

    // depth入力で座面奥行更新（既存挙動維持）
    $(document).on("input change", "#depth", function () {
      updateSeatDepth();
    });

    // 形変更
    $(document).on("change", 'input[name="top_plate"]', function () {
      updateSeatDepth();
      updatePreviewImages();
    });

    // 生地変更：bubble + 絞り込み + 先頭自動選択
    $(document).on("change", 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      const type = (this.dataset?.type || "").toLowerCase();
      const section = this.closest(".form.material");
      if (section && FABRIC_MATERIAL_TEXT[type]) setBubble(section, FABRIC_MATERIAL_TEXT[type]);
      rebuildColorSlidesByType(type);
      updatePreviewImages();
    });

    // カラー変更：bubble + プレビュー
    $(document).on("change", 'input[name="colortype2"]', function () {
      if (!this.checked) return;
      const type = (this.dataset?.type || "").toLowerCase();
      const section = this.closest(".form.material");
      if (section && COLOR_DESC_TEXT[type]) setBubble(section, COLOR_DESC_TEXT[type]);
      updatePreviewImages();
    });

    // 脚変更：プレビュー
    $(document).on("change", 'input[name="option"]', function () {
      updatePreviewImages();
    });

    // -------------------------
    // .order-summary リセット仕様（重要）
    // -------------------------
    const $frm = $('form[name="frm_detail"]');
    $frm.on("change input", "input, select, textarea", function () {
      const $t = $(this);

      // 内部保持用 hidden は除外
      if ($t.is("#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7")) return;

      // サイズ入力変更時の既存挙動は維持しつつ、毎回リセット
      resetOrderSummary();
    });

    // -------------------------
    // カート投入対象イベント（必ず preventDefault）
    // -------------------------
    $(document).on("click", "#modal-cart", function (e) {
      submitToRakutenCart(e);
    });
    $(document).on("click", ".btn-cart, .cartadd", function (e) {
      submitToRakutenCart(e);
    });
    $(document).on("submit", 'form[name="frm_detail"]', function (e) {
      submitToRakutenCart(e);
    });
    $(document).on("submit", "form[name='frm']", function (e) {
      submitToRakutenCart(e);
    });
  });

})(jQuery);
